import { createSlice } from "@reduxjs/toolkit";
import {
  GET_SECONDARY_SALES_ACHIEVED_SUCCESS,
  GET_SECONDARY_SALES_ACHIEVED_FAIL,
  GET_SECONDARY_SALES_TREND_SUCCESS,
  GET_SECONDARY_SALES_TREND_FAIL,
  GET_SECONDARY_SALES_TARGET_ACHIEVED_SUCCESS,
  GET_SECONDARY_SALES_TARGET_ACHIEVED_FAIL,
  GET_SECONDARY_SALES_TARGET_TREND_SUCCESS,
  GET_SECONDARY_SALES_TARGET_TREND_FAIL,
  GET_TEAMS_AVERAGE_TSI_SCORE_SUCCESS,
  GET_TEAMS_AVERAGE_TSI_SCORE_FAIL,
  GET_TEAMS_AVERAGE_TSI_SCORE_TREND_SUCCESS,
  GET_TEAMS_AVERAGE_TSI_SCORE_TREND_FAIL,
  GET_TEAMS_AVERAGE_TSR_SCORE_SUCCESS,
  GET_TEAMS_AVERAGE_TSR_SCORE_FAIL,
  GET_TEAMS_AVERAGE_TSR_SCORE_TREND_SUCCESS,
  GET_TEAMS_AVERAGE_TSR_SCORE_TREND_FAIL,
  GET_TEAMS_INCENTIVE_SUCCESS,
  GET_TEAMS_INCENTIVE_FAIL,
  GET_TEAMS_INCENTIVE_TREND_SUCCESS,
  GET_TEAMS_INCENTIVE_TREND_FAIL,
  GET_TEAMS_SOP_SUCCESS,
  GET_TEAMS_SOP_FAIL,
  GET_TEAMS_SOP_TREND_SUCCESS,
  GET_TEAMS_SOP_TREND_FAIL,
  GET_WSS_AUTO_VALUE_FTD_SUCCESS,
  GET_WSS_AUTO_VALUE_FTD_FAIL,
  GET_WSS_AUTO_VALUE_FTD_TREND_SUCCESS,
  GET_WSS_AUTO_VALUE_FTD_TREND_FAIL,
  GET_WSS_WSS_IN_BLOCK_SUCCESS,
  GET_WSS_WSS_IN_BLOCK_FAIL,
  GET_WSS__DARPAN_SYNC_DAYS_EXCEPTION_SUCCESS,
  GET_WSS_DARPAN_SYNC_DAYS_EXCEPTION_FAIL,
  GET_OUTLETS_BILLED_FTM_SUCCESS,
  GET_OUTLETS_BILLED_FTM_FAIL,
  GET_OUTLETS_BILLED_FTM_TREND_SUCCESS,
  GET_OUTLETS_BILLED_FTM_TREND_FAIL,
  GET_RSM_FTM_SUCCESS,
  GET_RSM_FTM_FAIL,
  GET_RSM_FTM_TREND_SUCCESS,
  GET_RSM_FTM_TREND_FAIL,
  SET_SELECTED_INSIGHTS,
} from "../constants/action-types";

const emptyDashboard = {
  secondarySalesAcheived: [],
  trend: [],
  secondarySalesTagetAcheived: [],
  targetTrend: [],
  teamsAverageTsiScore: [],
  teamsAverageTsiScoreTrend: [],
  teamsAverageTsrScore: [],
  teamsAverageTsrScoreTrend: [],
  teamsIncentive: [],
  teamsIncentiveTrend: [],
  teamsSop: [],
  teamsSopTrend: [],
  wssAutoValueFtd: [],
  wssAutoValueFtdTrend: [],
  wssWssInBlockCount: [],
  wssDarpanSyncDayExceptionCount: [],
  outletsBilledFtmCount: [],
  outletsBilledFtmCountTrend: [],
  rsmFtmSum: [],
  rsmFtmSumTrend: [],
};

// --- Dashboard Slice (secondary sales, teams, wss, sales-ops) ---
const dashboardSlice = createSlice({
  name: "dashBoardDetails",
  initialState: { ...emptyDashboard },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Secondary Sales
      .addCase(GET_SECONDARY_SALES_ACHIEVED_SUCCESS, (state, { payload }) => {
        state.secondarySalesAcheived = payload;
      })
      .addCase(GET_SECONDARY_SALES_TREND_SUCCESS, (state, { payload }) => {
        state.trend = payload;
      })
      .addCase(
        GET_SECONDARY_SALES_TARGET_ACHIEVED_SUCCESS,
        (state, { payload }) => {
          state.secondarySalesTagetAcheived = payload;
        }
      )
      .addCase(
        GET_SECONDARY_SALES_TARGET_TREND_SUCCESS,
        (state, { payload }) => {
          state.targetTrend = payload;
        }
      )
      // Teams
      .addCase(GET_TEAMS_AVERAGE_TSI_SCORE_SUCCESS, (state, { payload }) => {
        state.teamsAverageTsiScore = payload;
      })
      .addCase(
        GET_TEAMS_AVERAGE_TSI_SCORE_TREND_SUCCESS,
        (state, { payload }) => {
          state.teamsAverageTsiScoreTrend = payload;
        }
      )
      .addCase(GET_TEAMS_AVERAGE_TSR_SCORE_SUCCESS, (state, { payload }) => {
        state.teamsAverageTsrScore = payload;
      })
      .addCase(
        GET_TEAMS_AVERAGE_TSR_SCORE_TREND_SUCCESS,
        (state, { payload }) => {
          state.teamsAverageTsrScoreTrend = payload;
        }
      )
      .addCase(GET_TEAMS_INCENTIVE_SUCCESS, (state, { payload }) => {
        state.teamsIncentive = payload;
      })
      .addCase(GET_TEAMS_INCENTIVE_TREND_SUCCESS, (state, { payload }) => {
        state.teamsIncentiveTrend = payload;
      })
      .addCase(GET_TEAMS_SOP_SUCCESS, (state, { payload }) => {
        state.teamsSop = payload;
      })
      .addCase(GET_TEAMS_SOP_TREND_SUCCESS, (state, { payload }) => {
        state.teamsSopTrend = payload;
      })
      // WSS
      .addCase(GET_WSS_AUTO_VALUE_FTD_SUCCESS, (state, { payload }) => {
        state.wssAutoValueFtd = payload;
      })
      .addCase(GET_WSS_AUTO_VALUE_FTD_TREND_SUCCESS, (state, { payload }) => {
        state.wssAutoValueFtdTrend = payload;
      })
      .addCase(GET_WSS_WSS_IN_BLOCK_SUCCESS, (state, { payload }) => {
        state.wssWssInBlockCount = payload;
      })
      .addCase(
        GET_WSS__DARPAN_SYNC_DAYS_EXCEPTION_SUCCESS,
        (state, { payload }) => {
          state.wssDarpanSyncDayExceptionCount = payload;
        }
      )
      // Sales Operations
      .addCase(GET_OUTLETS_BILLED_FTM_SUCCESS, (state, { payload }) => {
        state.outletsBilledFtmCount = payload;
      })
      .addCase(GET_OUTLETS_BILLED_FTM_TREND_SUCCESS, (state, { payload }) => {
        state.outletsBilledFtmCountTrend = payload;
      })
      .addCase(GET_RSM_FTM_SUCCESS, (state, { payload }) => {
        state.rsmFtmSum = payload;
      })
      .addCase(GET_RSM_FTM_TREND_SUCCESS, (state, { payload }) => {
        state.rsmFtmSumTrend = payload;
      })
      // All failure cases reset to empty
      .addMatcher(
        (action) =>
          [
            GET_SECONDARY_SALES_ACHIEVED_FAIL,
            GET_SECONDARY_SALES_TREND_FAIL,
            GET_SECONDARY_SALES_TARGET_ACHIEVED_FAIL,
            GET_SECONDARY_SALES_TARGET_TREND_FAIL,
            GET_TEAMS_AVERAGE_TSI_SCORE_FAIL,
            GET_TEAMS_AVERAGE_TSI_SCORE_TREND_FAIL,
            GET_TEAMS_AVERAGE_TSR_SCORE_FAIL,
            GET_TEAMS_AVERAGE_TSR_SCORE_TREND_FAIL,
            GET_TEAMS_INCENTIVE_FAIL,
            GET_TEAMS_INCENTIVE_TREND_FAIL,
            GET_TEAMS_SOP_FAIL,
            GET_TEAMS_SOP_TREND_FAIL,
            GET_WSS_AUTO_VALUE_FTD_FAIL,
            GET_WSS_AUTO_VALUE_FTD_TREND_FAIL,
            GET_WSS_WSS_IN_BLOCK_FAIL,
            GET_WSS_DARPAN_SYNC_DAYS_EXCEPTION_FAIL,
            GET_OUTLETS_BILLED_FTM_FAIL,
            GET_OUTLETS_BILLED_FTM_TREND_FAIL,
            GET_RSM_FTM_TREND_FAIL,
            GET_RSM_FTM_FAIL,
          ].includes(action.type),
        () => ({ ...emptyDashboard })
      );
  },
});

// --- Insights Slice ---
const insightsSlice = createSlice({
  name: "insights",
  initialState: { selectedInsights: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(SET_SELECTED_INSIGHTS, (state, { payload }) => {
      state.selectedInsights = payload;
    });
  },
});

export const getDashboardReducer = dashboardSlice.reducer;
export const insightsReducer = insightsSlice.reducer;
